/* Result page tab */
$(document).ready(function(){
  $('.result-tabs-nav .tab-item').click(function() {
    $('.result-tabs-nav li').removeClass('active');
    $(this).parent().addClass('active');
    var currentTab = $(this).attr('data-tab');
    if (currentTab === 'All') {
      $('.wrapper-block-result').show(); 
    } else {
      $('.wrapper-block-result').hide(); 
      $('.wrapper-block-result[data-type="' + currentTab + '"]').show(); 
    }
    return false; 
  });
  if($('.image-with-text-wrapper .image-text-slide').length > 0) {
    $('.image-with-text-wrapper .image-text-slide').slick({
      arrows: true,
      dots: true,
      autoplay: true,
      prevArrow: $('.custom-slick-prev'),
      nextArrow: $('.custom-slick-next')
    });
  }
});


var $slickEl = $('.saloon-reviews');

$slickEl.slick({
  centerMode: true,
  centerPadding: '0px',
  slidesToShow: 3,
  focusOnSelect: true,
  arrows: true,
  dots: true,
  infinite: true,
  dots: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: true,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});

// $(document).ready(function () {
//   jQuery.getJSON("/cart.js", function (cart) {
//     childToParent(cart);
//     parentToChild(cart);
//   });
// });

/* ================== Bundle announcement bar pupop JS ================== */
if($('.bundle-offer-popup').length > 0) {
  $(document).on('click', "#bundle-announcement-bar", function() {
    console.log("Click event===========")
    $("#bundle-announcement-bar + .bundle-offer-popup").fadeIn("fast");
  });
  $(".bundle-offer-popup .close-btn").on('click', function() {
    $("#bundle-announcement-bar + .bundle-offer-popup").fadeOut("fast");
  });
  
  $(document).mouseup(function(e) {
      var container = $(".bundle-offer-popup .offer-popup-container");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.parent().fadeOut("fast");
      }
  });
}
/* ================== End Bundle announcement bar offer pupop JS ================== */
